import React, { Component } from 'react';
import './Utility.css';
import AccountUsage from './AccountUsage';
import { withRouter } from '../containers/WithRouter';

class Utility extends Component {
  constructor() {
    super();
    this.state = {
      showingUtility: 'checkUsage'
    };
  }

  showCheckUsage = () => {
    this.setState({
      showingUtility: 'checkUsage'
    });
    window.history.replaceState(null, '', `/#/utility/checkUsage`);
  };

  handleUrlParameter = () => {
    const name = this.props?.router?.params?.name;
    if (name) {
      this.setState({ showingUtility: name });
    }
  };

  componentDidMount() {
    this.handleUrlParameter();
  }

  render() {
    return (
      <div className="Utility">
        <h1>OPUS KTLO Utilities</h1>
        <s-box className="padding-all-xs" class="DetailBox">
          <s-row collapse="lg">
            <s-col span="1" class="divider-right buttonContainer">
              <s-row>
                <button
                  className={
                    this.state.showingUtility === 'checkUsage'
                      ? 'utilityButtonActive'
                      : 'utilityButton'
                  }
                  onClick={this.showCheckUsage}
                >
                  Account Usage
                </button>
              </s-row>
            </s-col>
            <s-col span="10">
              <div className="utilityPanel">
                {this.state.showingUtility === 'checkUsage' && <AccountUsage />}
              </div>
            </s-col>
          </s-row>
        </s-box>
      </div>
    );
  }
}

export default withRouter(Utility);
